var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      ref: "modal",
      attrs: { heading: "Move To Requisition", timesButton: false }
    },
    [
      !_vm.showResult
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.moveToRequisition($event)
                }
              }
            },
            [
              _c("input", {
                attrs: { type: "hidden", name: "_csrfToken" },
                domProps: { value: _vm.csrfToken }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-4" },
                [
                  _c("label", [_vm._v("Choose Job Ads")]),
                  _vm._v(" "),
                  _c("vue-select", {
                    attrs: { label: "title", options: _vm.requisitionJobs },
                    on: { search: _vm.fetchRequisitionJobs },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    option.job !== null
                                      ? option.job.title
                                      : option.display_name
                                  ) +
                                  " (#" +
                                  _vm._s(option.id) +
                                  ", " +
                                  _vm._s(
                                    option.person_specification.business_line
                                      .company.title
                                  ) +
                                  ")\n                "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3770997800
                    ),
                    model: {
                      value: _vm.selectedRequisitionData,
                      callback: function($$v) {
                        _vm.selectedRequisitionData = $$v
                      },
                      expression: "selectedRequisitionData"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
                _c("div", { staticClass: "cell shrink" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button primary",
                      attrs: { type: "submit" }
                    },
                    [_vm._v("Move")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell shrink" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button warning",
                      attrs: { type: "button" },
                      on: { click: _vm.toggleModal }
                    },
                    [_vm._v("Close")]
                  )
                ])
              ])
            ]
          )
        : _c("div", [
            _c("div", { staticClass: "mb-4" }, [
              _c("h4", [_vm._v("Result")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.results, function(result, index) {
                  return _c("li", { key: index }, [_vm._v(_vm._s(result))])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
              _c("div", { staticClass: "cell shrink" }, [
                _c(
                  "button",
                  {
                    staticClass: "button warning",
                    attrs: { type: "button" },
                    on: { click: _vm.toggleModal }
                  },
                  [_vm._v("Close")]
                )
              ])
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3232ea6", { render: render, staticRenderFns: staticRenderFns })
  }
}